<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
      <div class="two-factor-authentication">
        <h2 class="title">Autenticação de Dois Fatores</h2>
        <p class="instruction">Abra o seu aplicativo do Google Authenticator e insira o código de verificação do Pedbot</p>
        <vs-input id="inputTwoFactor" v-model="googleSecret" class="w-full" placeholder="Código de 6 digitos" required type="text" @keyup.enter="validate"/>
        <vs-button class="button w-full" color="primary" @click="validate">Enviar Código</vs-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      googleSecret: ''
    }
  },
  methods: {
    async validate() {
      const numericRegex = /^[0-9]+$/;
      if (!numericRegex.test(this.googleSecret)) {
        this.$vs.notify({
          title: 'Erro',
          text: 'O código deve ser apenas numérico.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
        return;
      }
      try {
        if (this.googleSecret) {
          await this.$store.dispatch('getAllUsers');
          const token = localStorage.getItem('accessToken')
          const email = localStorage.getItem('email');
          const response = this.$store.state.users.users
          const userData = response.find(user => user.email === email);
          const role = userData.role.display_name;

          await this.$store.dispatch('activityTwoFactor', {
            id: userData.id,
            token: token,
            alterObject: {"google2fa_secret": this.googleSecret, "identify": 1, "role": role, "email": email}
          }).then(() => {
            this.$vs.notify({
              title: 'Autenticação em 2 Fatores',
              text: 'Token Validado',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });

            this.$store.dispatch('fetchPermissions', {
              email: email,
              token: token
            }).then(responseData => {
              const permissions = responseData.data;
              localStorage.removeItem('permissions');
              localStorage.setItem('permissions', JSON.stringify(permissions));
              this.$router.push('/').then(() => window.location.reload());
            }).catch((error) => {
              console.error('Erro ao buscar permissões', error);
            })
          }).catch((error) => {
            console.error('Erro ao validar código de 2 fatores', error);
            this.$vs.notify({
              title: 'Autenticação em 2 Fatores Falhou',
              text: 'Token Inválido',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
            });
          })
        }
      } catch (error) {
        console.error('Ocorreu um erro ao validar a chave secreta:', error);
        this.$vs.notify({
          title: 'Autenticação em 2 Fatores Falhou',
          text: 'Token Chave Secreta Inválida',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      }
    },
  },
}

</script>

<style>
.two-factor-authentication {
  max-width: 500px;
  margin: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  border: 0.5px solid #ccc;
  border-radius: 8px;
  background-color: #efefef;
  border-color: #716e6e;
}

.title {
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
}

.form {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 16px;
  margin-bottom: 8px;
}

#inputTwoFactor {
  padding: 8px;
  font-size: 16px;
  margin-bottom: 16px;
  border: 1px solid #716e6e;
  border-radius: 4px;
}

.button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.button:hover {
  background-color: #0056b3;
}

.instruction {
  text-align: center;
  color: black;
  font-weight: 430;
  margin-bottom: 40px;
}
</style>
  